import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../../SbSharedRefineMenu/sbSharedRefineMenuHelpers';
import { addAndApplyFilter, removeAndApplyFilter } from '../../../actions/filterActions';

// components
import { SbRespRefineMenuStoneCutSelectInput } from './SbRespRefineMenuStoneCutSelectInput';

export class SbRespRefineMenuStoneCutSelectComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stoneCutMap: {},
            loadStoneCutMapInitialized: false,
        };

        this.onChange = this.onChange.bind(this);
    }

    componentDidUpdate() {
        if (this.props.isClient && !this.state.loadStoneCutMapInitialized) {
            this.loadStoneCutMap();
            this.setState({
                loadStoneCutMapInitialized: true,
            });
        }
    }
    onChange(checked, urlLabel) {
        return checked ? this.props.onSelect(urlLabel) : this.props.onDeselect(urlLabel);
    }

    loadStoneCutMap() {
        return import(
            /* webpackChunkName: "sbRespRefineMenuStoneCutComponentMap" */
            './sbRespRefineMenuStoneCutComponentMap'
        ).then(moduleExport => {
            this.setState({ stoneCutMap: moduleExport.stoneCutMap });
        });
    }

    render() {
        const { itemSearch, valuesToShow, filterName } = this.props;
        const { appliedFilters } = itemSearch;

        const appliedFilterValues = getFilterValues(appliedFilters, filterName);

        return (
            <div>
                {valuesToShow.map((item, index) => {
                    const isChecked = appliedFilterValues.some(
                        appliedValue => appliedValue.urlLabel === item.urlLabel
                    );
                    return (
                        <SbRespRefineMenuStoneCutSelectInput
                            count={item.count}
                            checked={isChecked}
                            linkReference={item.linkReference}
                            linkable={item.linkable}
                            value={item.urlLabel}
                            onChange={checked => {
                                this.onChange(checked, item);
                            }}
                            text={item.displayName}
                            stoneCut={item.urlLabel}
                            key={`${item.urlLabel}-${index}`}
                            stoneCutMap={this.state.stoneCutMap}
                            isHidden={item.isHidden}
                        />
                    );
                })}
            </div>
        );
    }
}

SbRespRefineMenuStoneCutSelectComponent.propTypes = {
    isClient: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    onDeselect: PropTypes.func.isRequired,
    filterName: PropTypes.string.isRequired,
    valuesToShow: PropTypes.array.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch, props) {
    return {
        onSelect(changedValue) {
            dispatch(addAndApplyFilter(props.filterName, changedValue));
        },
        onDeselect(changedValue) {
            dispatch(removeAndApplyFilter(props.filterName, changedValue));
        },
    };
}

export const SbRespRefineMenuStoneCutSelect = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbRespRefineMenuStoneCutSelectComponent),
    {
        itemSearch: graphql`
            fragment SbRespRefineMenuStoneCutSelect_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
